// Role: Patient
import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Button, Paper, PaperTitle } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import { compose, map } from 'ramda';

import HistoryListItem from 'components/HistoryListItem';

import s from './styles.module.scss';

const HistoryList = ({ data, match, t }) => (
  <Paper data-test="HistoryList">
    <PaperTitle>{t('reports.recentReports')}</PaperTitle>
    <div className={s.scrollList}>
      {map(
        ({ date, id, read }) => (
          <HistoryListItem dot={!read} key={id} baseUrl={match.url} id={id}>
            {date}
          </HistoryListItem>
        ),
        data,
      )}
    </div>
    <div className={s.viewAllContainer}>
      <Button
        className={s.bottomButton}
        component={Link}
        to="/reports-history"
        variant="primary"
        outlined
      >
        {t('reports.viewAllReports')}
      </Button>
    </div>
  </Paper>
);

HistoryList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      read: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation(),
  withRouter,
)(HistoryList);
